import { isApiHttpError } from '../api/httpClient'

function hasStatus(error: unknown, statusCode: number): boolean {
  if (isApiHttpError(error)) {
    return error.status === statusCode
  }

  if (error instanceof Response) {
    return error.status === statusCode
  }

  if (Boolean(error) && typeof error === 'object' && 'status' in error) {
    return Number((error as { status?: unknown }).status) === statusCode
  }

  if (error instanceof Error) {
    return error.message.includes(String(statusCode))
  }

  return false
}

export function isUnauthorizedError(error: unknown): boolean {
  return hasStatus(error, 401)
}

export function isForbiddenError(error: unknown): boolean {
  return hasStatus(error, 403)
}

export function isAbortError(error: unknown): boolean {
  if (error instanceof DOMException) {
    return error.name === 'AbortError'
  }

  return Boolean(error) && typeof error === 'object' && (error as { name?: unknown }).name === 'AbortError'
}

export function isNetworkError(error: unknown): boolean {
  if (isAbortError(error)) {
    return false
  }

  if (error instanceof TypeError) {
    return true
  }

  if (error instanceof Error) {
    const message = error.message.toLowerCase()
    return message.includes('network') || message.includes('failed to fetch')
  }

  return false
}

/** Message of a failed user action: a generic text for a server error, the API message for a client error. */
export function resolveActionErrorMessage(error: unknown, fallbackMessage: string): string {
  if (isApiHttpError(error)) {
    if (error.status >= 500) {
      return 'Ошибка сервера. Попробуйте позже.'
    }
    if (error.status >= 400) {
      return error.message?.trim() || 'Проверьте данные и повторите попытку.'
    }
  }

  return error instanceof Error ? error.message : fallbackMessage
}
